import React from 'react';
import { LogoOP } from '@op/opds.opux-logo/op';
import { Action, ScreenReaderOnly, ServiceIdentity } from '@op/opds.opux';
import { space } from '@op/opds.tokens';
import { Message, useMessageGetter } from '@messageformat/react';
import LanguageChooser from './LanguageChooser';

const Header = ({ mainContentElementId }) => {
    const serviceName = useMessageGetter()('fp.serviceName');
    return (
        <header id='fullpagelogin-header'>
            <div id='fullpagelogin-header-content'>
                <div id='main-content-link-container'>
                    <Action id='main-content-link' href={'#' + mainContentElementId} size='small' tabIndex={0}>
                        <Message id='fp.mainContentLinkText' />
                    </Action>
                </div>
                <div className='fullpagelogin-service-identity-visible'>
                    <ScreenReaderOnly>OP</ScreenReaderOnly>
                    <ServiceIdentity serviceName={serviceName} style={{ margin: space.xxs }} />
                </div>
                <div className='fullpagelogin-logo-op-visible'>
                    <LogoOP style={{ margin: space.xxs }} label='OP' />
                </div>
                <LanguageChooser />
            </div>
        </header>
    );
};

export default Header;
